import store from "../../store/index";
import axios from "axios";
import { BASE_URL } from "@/env";
import setTokenUser from "../office/tokens/refreshTokenUser";
import setTokenMuni from "../office/tokens/refreshTokenMuni";
import GeneralFunctions from "../helpers/generalFunctions";
import setTokenRelations from "../office/tokens/refreshTokenRelations";
import { useToast } from "vue-toastification";

const toast = useToast();

const apiOffice = axios.create({
  baseURL: BASE_URL,
  timeout: 20000,
});


apiOffice.interceptors.request.use(
  (config) => {
    const currentToken = localStorage.getItem("token");
    if (currentToken) {
      // console.log("token ", currentToken);
      config.headers["auth-header"] = `${currentToken}`;
      if (store.state.CidiCookie) {
        config.headers["cidi-header"] = `${store.state.CidiCookie}`;
      }
    }
    return config;
  },
  (error) => {
    // console.log("hubo un error en cambiar el token", error);
    return Promise.reject(error);
  },
);
apiOffice.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (!error.response && error.code === "ERR_NETWORK") {
      if (!originalRequest._retryNetwork) {
        originalRequest._retryNetwork = true;
        await new Promise((r) => setTimeout(r, 1500));
        return apiOffice(originalRequest);
      }
      return Promise.reject(error);
    }

    if (error.response?.status === 500 || error.response?.status === 401) {
      if (originalRequest._retryAuth) {
        return Promise.reject(error);
      }
      originalRequest._retryAuth = true;

      let errorMessage = error.response.data?.message;

      if (
        error.response.data instanceof Blob &&
        error.response.data.type === "application/json"
      ) {
        try {
          // Convertimos el Blob de vuelta a texto y lo parseamos como JSON
          const textError = await error.response.data.text();
          const jsonError = JSON.parse(textError);
          errorMessage = jsonError.message;
        } catch (e) {
          console.error("No se pudo leer el error del Blob:", e);
        }
      }

      if (errorMessage.includes("Token de usuario expirado")) {
        try {
          const user = store.state?.user;
          let success = false;
          if (user?.role) {
            success = await setTokenMuni();
          } else {
            success = await setTokenUser();
          }

          if (!success) {
            // console.log("Fallo la renovación del token, cerrando sesión...");
            await GeneralFunctions.logOutOffice();
            return Promise.reject(error);
          }

          // Actualizar el token en los headers y reintentar la solicitud original
          let newToken = localStorage.getItem("token");
          newToken = store.state.token ?? newToken;
          if (newToken) {
            originalRequest.headers["auth-header"] = `${newToken}`;
          }

          // Reintentar la solicitud
          return apiOffice(originalRequest);
        } catch (refreshError) {
          // console.error("Error al renovar el token", refreshError);
          // Opcional: Redirigir al usuario al inicio de sesión
          await GeneralFunctions.logOutOffice();
          return Promise.reject(error);
        }
      } else if (
        error.response.data?.message === "Token de representante expirado"
      ) {
        try {
          let success = await setTokenRelations();

          if (!success) {
            // console.log("Fallo la renovación del token, cerrando sesión...");
            await GeneralFunctions.logOutOffice();
            return Promise.reject(error);
          }

          // Actualizar el token en los headers y reintentar la solicitud original
          const newToken = localStorage.getItem("token");
          if (newToken) {
            originalRequest.headers["auth-header"] = `${newToken}`;
          }

          // Reintentar la solicitud
          return apiOffice(originalRequest);
        } catch (error) {
          // console.error("Error al renovar el token", error);
          // Opcional: Redirigir al usuario al inicio de sesión
          await GeneralFunctions.logOutOffice();
          return Promise.reject(error);
        }
      } else if (error.response.data?.message === "CIDI_ERR_EXP") {
        toast.error("Sesion en CIDI expirada, vuelve a ingresar.");
        await new Promise((resolve) => setTimeout(resolve, 3000));
        await GeneralFunctions.logOutOffice();
      }
    }

    // Si el error no está relacionado con el token expirado
    return Promise.reject(error);
  },
);

export default apiOffice;
